export { OpeningHourCard } from "./opening-hour-card";
export type { OpeningHourProps } from "./interface";
